import { render, staticRenderFns } from "./SceneLibNew.vue?vue&type=template&id=3a527d56&scoped=true"
import script from "./SceneLibNew.vue?vue&type=script&lang=js"
export * from "./SceneLibNew.vue?vue&type=script&lang=js"
import style0 from "./SceneLibNew.vue?vue&type=style&index=0&id=3a527d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a527d56",
  null
  
)

export default component.exports